import { takeLatest } from "redux-saga/effects";

import chatActionCreators from "../../actions/chat";
import sagasUtils from "../../../utils/sagas.utils";

export function* watchSyncPropertyMessages() {
  yield takeLatest(chatActionCreators.syncPropertyMessages.toString(), sagasUtils.syncMessages);
}
